import React from 'react';
import { Badge } from 'react-bootstrap';
import { status_full as PROJ_STATUSES_RU, statusFullWithPolicy as POLICY_PROJ_STATUSES_RU, statusFullWithGoal as GOAL_PROJ_STATUSES_RU, statusFullWithTech as TECH_PROJ_STATUSES_RU } from '../../helpers/passport';
import { status_full as BUY_STATUSES_RU, state_full as BUY_STATES_RU } from '../../helpers/buy';
import { status_full as RESULT_STATUSES_RU } from '../../helpers/StrategyProject/stratProjectHelpers';
import { status_full as PORT_PROJ_STATUSES_RU } from '../../helpers/PortfolioProject/ArticlesHelper';
import { status_full as PROJ_INCOME_STATUSES_RU } from '../../helpers/PortfolioProject/IncomeHelper';
import { status_full_m as FACTDATA_RU_M, status_full_f as FACTDATA_RU_F, status_full_special as RECEIPTS_STATUSES_RU_M } from '../../helpers/factdata';

import { status_full_m as PERIODS_RU, status_full_m_current as REPORT_PERIODS_RU } from '../../helpers/periods';
import { MILESTONE_STATUSES_RU } from '../../helpers/report';

const STATUS_SETS_DICTIONARY = {
  strategy: PROJ_STATUSES_RU,
  policy: POLICY_PROJ_STATUSES_RU,
  goal: GOAL_PROJ_STATUSES_RU,
  tech: TECH_PROJ_STATUSES_RU,
  buy: BUY_STATUSES_RU,
  buyState: BUY_STATES_RU,
  resultState: RESULT_STATUSES_RU,
  portfolioProj: PORT_PROJ_STATUSES_RU,
  projIncomeState: PROJ_INCOME_STATUSES_RU,
  milestones: MILESTONE_STATUSES_RU,
  receipts: RECEIPTS_STATUSES_RU_M,

  // factdata
  article: FACTDATA_RU_F,
  teamMember: FACTDATA_RU_M,
  income: FACTDATA_RU_M,
  request: FACTDATA_RU_F,

  // periods
  resultPeriods: PERIODS_RU,
  reportPeriods: REPORT_PERIODS_RU,
};

export default function StatusBadge({
  type, status, height, width,
}) {
  const foundStatusSet = STATUS_SETS_DICTIONARY[type];
  let foundStatus;

  if (foundStatusSet) foundStatus = foundStatusSet[status];

  if (foundStatus) {
    return (
      <Badge
        style={{
          width, height, whiteSpace: 'normal', alignSelf: 'center',
        }}
        pill
        bg={foundStatus.bg}
      >
        {foundStatus.label}
      </Badge>
    );
  }

  return <Badge pill bg="secondary" />;
}
